<template>
    <div>
        <el-drawer
            title="个人信息"
            @close="closeDrawer"
            :size="300"
            append-to-body="appendToBody"
            :visible.sync="userVisit">
            <div class="user-drawer-body">
                <div class="user-info">
                    <!-- 头像 -->
                    <el-avatar fit="fill" class="info-avatar" :src="userInfo.sex === 2 ? avatarUrl2 : avatarUrl1"></el-avatar>
                    <!-- 个人信息展示 -->
                    <div class="info-item">
                        <span class="info-label">昵称: {{ userInfo.realname || userInfo.username }}</span>
                        <span class="info-button" @click="editName" v-if="isLogined && isMember">编辑</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">性别: {{ userInfo.sex === 1 ? '男' : userInfo.sex === 2 ? '女' : '' }}</span>
                        <span class="info-button" @click="editSex" v-if="isLogined && isMember">编辑</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">邮箱: {{ userInfo.email }}</span>
                        <!-- <span class="info-button">编辑</span> -->
                    </div>
                    <div class="info-item">
                        <span class="info-label">手机: {{ userInfo.phone }}</span>
                        <!-- <span class="info-button">编辑</span> -->
                    </div>
                    <div class="info-item" v-if="isLogined">
                        <span class="info-label">密码: ●●●●●●</span>
                        <span class="info-button" @click="changePassword" v-if="isMember">重置</span>
                    </div>
                </div>

                <div class="bottom-container logout-container" @click="logout" v-if="isLogined">
                    <span class="logout">退出登录</span>
                </div>
                <div class="bottom-container login-container" @click="toLogin" v-else>
                    <span class="login">登录</span>
                </div>
            </div>
        </el-drawer>
        <el-dialog title="修改" :visible.sync="dialog.visit" :close-on-click-modal="false" width="38%">
            <el-form :model="dialog.form" :rules="rules" label-width="100px" ref="editForm">
                <el-form-item label="昵称" prop="realname" v-if="dialog.showName">
                    <el-input v-model="dialog.form.realname" placeholder="请输入昵称" clearable></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="sex" style="width: 80%;" v-if="dialog.showSex">
                    <el-radio v-model="dialog.form.sex" :label="1">男</el-radio>
                    <el-radio v-model="dialog.form.sex" :label="2">女</el-radio>
                </el-form-item>
                <el-form-item label="原密码" prop="oldPassword" v-if="dialog.showPassword">
                    <el-input type="password" v-model="dialog.form.oldPassword" placeholder="请输入原密码" clearable></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="oldPassword" v-if="dialog.showPassword">
                    <el-input type="password" v-model="dialog.form.newPassword" placeholder="请输入新密码" clearable></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="rePassword" v-if="dialog.showPassword">
                    <el-input type="password" v-model="dialog.form.rePassword" placeholder="请确认密码" clearable></el-input>
                </el-form-item>
            </el-form>
             <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click.native="submit">提 交</el-button>
                <el-button @click.native="dialog.visit = false">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
    
</template>

<script>
import {bingList, videoList} from './backgroud-img'
import avatar1 from '../../static/image/avatar1.png';
import avatar2 from '../../static/image/avatar2.png';

export default {
    props: {
        'userVisit': false,
        'isMember': false,
        'appendToBody': false,
    },
    data() {
        return {
            avatarUrl1: avatar1,
            avatarUrl2: avatar2,
            userInfo: {},
            isLogined: false,
            rules: {
                oldPassword: [
                    {required: true, message: '请输入原密码', trigger: 'blur'},
                    {min: 6, max: 20, message: '密码长度应为6到20个字符', trigger: 'blur'},
                ],
                newPassword: [
                    {required: true, message: '请输入新密码', trigger: 'blur'},
                    {min: 6, max: 20, message: '密码长度应为6到20个字符', trigger: 'blur'},
                ],
                rePassword: [
                    {required: true, message: '请输入确认密码', trigger: 'blur'},
                    {min: 6, max: 20, message: '密码长度应为6到20个字符', trigger: 'blur'},
                ],
                realname: [{required: true, message: '昵称不能为空', trigger: 'blur'}],
            },
            dialog: {
                'visit': false,
                'form': {
                    'realname': '',
                    'sex': '1'
                },
                'showName': false,
                'showPassword': false,
            }
        }
    },
    watch: {
        'userVisit': {
            handler(value) {
                if (value) {
                    this.getUserInfo();
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        editName() {
            this.dialog = {
                'visit': true,
                'form': {
                    'id': this.userInfo.id,
                    'realname': this.userInfo.realname
                },
                'showName': true,
                'showPassword': false,
                'showSex': false,
            }
        },
        editSex() {
            this.dialog = {
                'visit': true,
                'form': {
                    'id': this.userInfo.id,
                    'sex': this.userInfo.sex
                },
                'showSex': true,
                'showName': false,
                'showPassword': false,
            }
        },
        changePassword() {
            this.dialog = {
                'visit': true,
                'form': {
                    'id': this.userInfo.id,
                },
                'showName': false,
                'showPassword': true,
                'showSex': false,
            }
        },
        getUserInfo() {
            const userInfo = localStorage.getItem('userInfo');
            if(userInfo != null){
                this.userInfo = JSON.parse(userInfo);
                this.isLogined = true;
            }
        },
        closeDrawer() {
            this.$emit('update:userVisit', false);
            this.$emit("closeUserDrawer")
        },
        logout () {
            this.$confirm('是否确认退出登录?', '提示', {}).then(() => {
                const url = this.isMember ? '/emc-member-auth/logout' : '/sys/logout';
                this.$api.get(url).then(res => {
                    if (res.data.success) {
                        localStorage.removeItem('user');
                        localStorage.removeItem('userInfo');
                        localStorage.removeItem('token');
                        this.userInfo = {};
                        this.closeDrawer();
                        this.isLogined = false;
                        this.$emit("logout");
                        this.$notify.success('已退出登录')
                    }
                })
            })
        },
        toLogin() {
            this.$router.push({path: '/login'});
        },
        submit() {
            this.$refs.editForm.validate((valid) => {
                if (valid) {
                    const url = this.dialog.showPassword ? '/emcMember/changePassword' : '/emcMember';
                    this.$api.put(url, this.dialog.form).then(res => {
                        if (res.data.success) {
                            this.dialog.visit = false;
                            this.$notify.success('修改成功')
                            if (this.dialog.showName) {
                                this.userInfo.realname = this.dialog.form.realname;
                                localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
                            }
                            if (this.dialog.showSex) {
                                this.$emit("changeSex", this.dialog.form.sex);
                                this.userInfo.sex = this.dialog.form.sex;
                                localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
                            }
                        } else {
                            this.$notify.error(res.data.message)
                        }
                    })
                }
            })
            
        }
    }
}
</script>

<style lang="scss" scoped>
.user-drawer-body {
    width: 100%; 
    height: 100%;
    background-color: #f0f0f0;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}

.user-info {
    width: 88%;
    height: auto;
    margin-top: 10px;
    padding: 10px;
    background-color: #fff;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.info-avatar {
    margin: 10px;
}

.info-item {
    width: 100%;
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #222222;
}

.info-label {
}

.info-button:hover {
    color: rgb(37, 99, 198);
    cursor: pointer;
}

.bottom-container {
    display: flex;
    width: 88%;
    height: 13px;
    background-color: #fff;
    border-radius: 12px;
    justify-content: center;
    margin-top: auto;
    padding: 10px;
    margin-bottom: 10px;
    cursor: pointer;
}

.logout-container {
    color: #d43c3c;
}

.login-container {
    color: rgb(37, 99, 198);
}
</style>



// WEBPACK FOOTER //
// src/views/classify/UserDrawer.vue